//篮球 杯赛 FIBA Women's Asia Cup|国际篮联女子亚洲杯 full
import PlatfromBasketballFIBAWAFull from '@containers/platfrom_basketball/basketballCupFull_FIBAWA'

export default {
  PlatfromBasketballFIBAWAFull,
}
